import React, { createContext } from 'react';
import PropTypes from 'prop-types';


export const ConfigContext = createContext({
    pageId: '',
});


export function ConfigProvider(props) {
    const {
        children,
        config,
    } = props;

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
}

ConfigProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    config: PropTypes.shape({}).isRequired,
};
